<template>
	<div
		class="video"
		:class="{ has_border: has_border === 'Yes' }"
	>
		<div
			class="play_button"
			@click="modalOpen"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="30"
				height="40"
				viewBox="0 0 30 40"
			>
				<path
					id="Polygon_1"
					data-name="Polygon 1"
					d="M20,3.606,3.737,28H36.263L20,3.606M20,0,40,30H0Z"
					transform="translate(30) rotate(90)"
					fill="#fff"
				/>
			</svg>

		</div>

		<img
			v-if="video_poster"
			class="video_poster"
			v-lazy="video_poster"
			alt="video_poster"
			:class="{ has_border: has_border === 'Yes' }"
		/>
		<div
			class="modal"
			:class="{ open: isModalOpen == true }"
			@click="modalClose"
		>
			<div
				class="iframe__container"
				v-if="isModalOpen === true"
			>

				<div
					class="close_image"
					@click="modalClose"
				>
					<close-button type='grey'></close-button>
				</div>

				<iframe
					class="responsive__iframe"
					:src="video_source  + setAutoplay"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
import CloseButton from './CloseButton.vue';
export default {
	data() {
		return {
			isModalOpen: false,
			aosStatus: null,
			isAnimatedIn: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		video_poster: {
			type: String,
		},
		video_source: {
			type: String,
			default: '',
		},
		has_border: {
			default: 'No',
		},
	},

	computed: {
		setAutoplay() {
			if (this.isModalOpen === false) {
				return '?autoplay=0';
			} else {
				return '?autoplay=1';
			}
		},
	},

	watch: {},

	methods: {
		modalOpen() {
			this.sourceVideo = this.video_source;
			this.isModalOpen = true;
			this.$emit('isModalOpen', true);
			document.body.classList.add('modal-open');
		},

		modalClose() {
			this.sourceVideo = '';
			this.isModalOpen = false;
			this.$emit('isModalOpen', false);
			document.body.classList.remove('modal-open');
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			document.body.classList.remove('modal-open');
			this.modalClose();
		},
	},

	components: { CloseButton },

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.video {
	width: 100%;
	height: 100%;
	min-width: 100px;
	min-height: 100px;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	aspect-ratio: 18 / 9;

	@media (max-width: $tablet) {
		min-height: auto;
	}

	.inner {
		grid-column: 1 / span 12;

		@media (max-width: $tablet) {
			grid-column: 1 / span 12;
		}
	}
	/* 
	&.has_border {
		&::before {
			content: '';
			display: inline-block;
			width: 1px;
			height: 100%;
			background: var(--black);
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			z-index: 50;
		}
	} */

	img {
		&.video_poster {
			object-fit: cover;
			width: 100%;
			height: 100%;
			transition: 0.2s ease all;
			transform: scale(1);

			&.has_border {
				margin-right: 80px;

				@media (max-width: $tablet) {
					margin-right: 0;
				}
			}
		}
	}

	.play {
		min-width: 85px;
		width: 20% !important;
		max-width: 140px !important;
		position: absolute;
		z-index: 10;
		transition: 0.2s ease all;
		transform: scale(1);

		@media (max-width: $tablet) {
			height: 100px;
		}

		&:hover {
			transform: scale(1.25);
			cursor: pointer;
		}
	}

	.play_button {
		width: 72px;
		height: 72px;
		border-radius: 50%;
		background: var(--cobalt);
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		z-index: 10;
		/* transform: scale(1); */
		transition: 0.2s ease all;
		/* opacity: 0.75; */
		/* border: var(--border); */

		svg {
			position: absolute;
			transform: translate(2px);
			width: 30px;

			path {
				fill: var(--white);
				transition: 0.2s ease all;
			}
		}

		&:hover {
			background: var(--midnight);
			transition: 0.2s ease all;
			/* transform: scale(1.25); */
			cursor: pointer;
			/* opacity: 1; */

			svg {
				path {
					fill: var(--cobalt);
				}
			}
		}
	}

	.modal {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.9);
		opacity: 0;
		pointer-events: none;
		transition: 0.2s ease all;
		z-index: 999;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		grid-template-rows: 1fr auto 1fr;
		justify-content: center;
		align-items: center;

		@media (max-width: $mobile) {
			grid-template-columns: 16px 1fr 16px;
		}

		@media (max-width: $mobile) and (orientation: landscape) {
			grid-template-columns: repeat(12, 1fr);
		}

		&.open {
			opacity: 1;
			pointer-events: all;
		}

		// iframe {
		//   grid-column: 3 / span 8;
		//   grid-row: 2 / span 1;
		// }

		.iframe__container {
			position: relative;
			// overflow: hidden;
			width: 100%;
			aspect-ratio: 16 / 9;
			grid-column: 4 / span 6;
			grid-row: 2 / span 1;
			min-width: 800px;
			min-height: 400px;

			@media (max-width: $tablet) {
				grid-column: 2 / span 1;
				align-items: center;
				min-width: 300px;
			}

			@media (max-width: $mobile) and (orientation: portrait) {
				min-width: 100%;
				min-height: 20vh;
				min-width: 300px;
			}

			@media (max-width: $mobile) and (orientation: landscape) {
				grid-column: 4 / span 6;
				min-width: 300px;
			}

			.close_image {
				display: flex;
				position: absolute;
				grid-column: 11 / span 1;
				z-index: 10;
				top: -50px;
				right: -50px;

				@media (min-width: 0px) {
					right: 0px;
					width: 24px;
					height: 24px;
					/* background: var(--midnight); */
					border-radius: 50%;
					justify-content: center;
					align-items: center;
					transition: 0.2s ease all;
					/* border: var(--border); */

					&::v-deep {
						.close_button {
							svg {
								path {
									fill: var(--white);
								}
							}
						}
					}

					&:hover {
						cursor: pointer;
						/* background: var(--midnight); */
						transition: 0.2s ease all;

						/* svg {
							width: 8px;

							line {
								stroke: var(--black);
								stroke-width: 5px;
							}
						} */
					}

					svg {
						width: 8px;

						line {
							stroke: var(--white);
							stroke-width: 5px;
						}
					}
				}
			}
		}

		/* Then style the iframe to fit in the container div with full height and width */
		.responsive__iframe {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
			max-height: 100%;
			min-width: 100%;
			min-height: 400px;
			aspect-ratio: 16 / 9;

			@media (max-width: $mobile) {
				min-height: auto;
			}
		}
	}
}
</style>
